import { PostAPI } from 'Components/Helper/Helpers';

export const Update = async (request) => {
    return PostAPI(request, 'CreditInstitution/Update');
};

export const Select = async (request) => {
    return PostAPI(request, 'CreditInstitution/Select');
};

export const IsOnOff = async (request) => {
    return PostAPI(request, 'CreditInstitution/IsOnOff');
};

export const SelectReport = async (request) => {
    return PostAPI(request, 'CreditInstitution/SelectReport');
};

export const UpdateBalance = async (request) => {
    return PostAPI(request, 'CreditInstitution/UpdateUserBalance');
};

export const AddBeneficiary = async (request) => {
    return PostAPI(request, 'CreditInstitution/AddBeneficiary');
};

export const AddOwnBeneficiary = async (request) => {
    return PostAPI(request, 'CreditInstitution/AddOwnBeneficiary');
};

export const SelectBank = async (request) => {
    return PostAPI(request, 'CreditInstitution/SelectBank');
};

export const SelectBeneficiary = async (request) => {
    return PostAPI(request, 'CreditInstitution/SelectBeneficiary');
};

export const SelectOwnBeneficiary = async (request) => {
    return PostAPI(request, 'CreditInstitution/SelectOwnBeneficiary');
};
export const UpdateBeneficiary = async (request) => {
    return PostAPI(request, 'CreditInstitution/UpdateBeneficiary');
};
export const UpdateOwnBeneficiary = async (request) => {
    return PostAPI(request, 'CreditInstitution/UpdateOwnBeneficiary');
};

export const DeleteBene = async (request) => {
    return PostAPI(request, 'CreditInstitution/Delete');
};
export const DeleteOwnBene = async (request) => {
    return PostAPI(request, 'CreditInstitution/DeleteOwnBene');
};

export const BankToOtherTransfer = async (request) => {
    return PostAPI(request, 'CreditInstitution/BankToOtherTransfer');
};

export const BankToBankTransfer = async (request) => {
    return PostAPI(request, 'CreditInstitution/BankToBankTransfer');
};

export const SelfTransfer = async (request) => {
    return PostAPI(request, 'CreditInstitution/SelfTransfer');
};

export const SelectAccountSummery = async (request) => {
    return PostAPI(request, 'CreditInstitution/GetAccountSummery');
};

export const SelectOwnAccountSummery = async (request) => {
    return PostAPI(request, 'CreditInstitution/GetOwnAccountSummery');
};

export const SelectBeneByID = async (request) => {
    return PostAPI(request, 'CreditInstitution/GetBeneByID');
};

export const SelectOwnBeneByID = async (request) => {
    return PostAPI(request, 'CreditInstitution/GetOwnBeneByID');
};